export default {
  company: "Bedrijfsadres",
  main: "Primair adres",
  post: "Post adres",
  invoice: "Facturatie adres",
}
